import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { MeetingEndIndex } from '@/pages/meeting/MeetingEndIndex';

const searchSchema = z.object({
	id: z.string().optional(),
	endedForAll: z.boolean().optional(),
});

export const Route = createFileRoute('/meeting-end')({
	validateSearch: searchSchema,
	component: MeetingEndIndex,
});
